"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var fails = require("../internals/fails");
var classof = require("../internals/classof-raw");
var $Object = Object;
var split = uncurryThis("".split);
module.exports = fails(function() {
  return !$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classof(it) === "String" ? split(it, "") : $Object(it);
} : $Object;
